import {
  FirestoreTimeoutError,
  recoverFirestoreConnection,
  withFirestoreTimeout,
} from './firestoreTimeout';

// The user document is the only Firestore read that must finish before the
// authenticated app can render. Give a slow Safari connection a bounded first
// attempt, recover the Firestore transport, then try once more. This keeps the
// old infinite loader from becoming an arbitrarily long series of retries.
const USER_BOOTSTRAP_READ_TIMEOUT_MS = 8_000;

export async function readUserBootstrap<T>(
  read: () => Promise<T>,
  label: string,
): Promise<T> {
  try {
    return await withFirestoreTimeout(read(), {
      ms: USER_BOOTSTRAP_READ_TIMEOUT_MS,
      label,
    });
  } catch (error) {
    if (!(error instanceof FirestoreTimeoutError)) throw error;
    await recoverFirestoreConnection();
    return withFirestoreTimeout(read(), {
      ms: USER_BOOTSTRAP_READ_TIMEOUT_MS,
      label: `${label}-retry`,
    });
  }
}
